import React from "react";
import LoginComponent from "../component/Login";

const SuperAdminLoginPage = () => <LoginComponent platformLogin />;

export default SuperAdminLoginPage;
